/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   getQueryBedroomCount
 */

import type {
  Filters,
  FloorplanListing,
  Listable,
  NormalFloorplanListingData,
  Property,
} from '@zcode/state-type'

import { getQueryBuildingBedroomCount } from './getQueryBuildingBedroomCount'
import { getQueryListingBedroomCount } from './getQueryListingBedroomCount'

export const getQueryBedroomCount = ({
  entity,
  filters,
  floorplan,
}: {
  entity: Listable | Property
  filters: Partial<Filters> | undefined
  floorplan: FloorplanListing<NormalFloorplanListingData> | null | undefined
}) => {
  const { isBuilding, isFloorplan } = entity

  if (isBuilding && !isFloorplan) {
    if (floorplan) {
      return getQueryListingBedroomCount(floorplan, filters)
    }
    return getQueryBuildingBedroomCount(entity, filters)
  }

  return getQueryListingBedroomCount(entity, filters)
}
